import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="treegrid--atom"
export default class TreegridAtomController extends Controller {
	connect() {
		this.element.setAttribute("tabindex", "-1")

		this.element.addEventListener("keydown", this.onKeyDown)
		this.element.addEventListener("click", this.onClick)
		this.element.addEventListener("dblclick", this.onDoubleClick)
	}

	disconnect() {
		this.element.removeEventListener("keydown", this.onKeyDown)
		this.element.removeEventListener("click", this.onClick)
		this.element.removeEventListener("dblclick", this.onDoubleClick)
	}

	/** @param {KeyboardEvent} event */
	onKeyDown = (event) => {
		if (!this.isFocused) return

		switch (event.key) {
			case "ArrowRight": {
				if (this.next) {
					this.next.focus()
					break
				}
				return
			}
			case "ArrowLeft": {
				if (this.prev) {
					this.prev.focus()
					break
				}
				return
			}
			case "ArrowDown": {
				if (this.lower) {
					this.lower.focus()
					break
				}
				return
			}
			case "ArrowUp": {
				if (this.upper) {
					this.upper.focus()
					break
				}
				return
			}
			case "Home": {
				if (event.ctrlKey && this.top) {
					this.top.focus()
					break
				}

				if (this.first) {
					this.first.focus()
					break
				}
				return
			}
			case "End": {
				if (event.ctrlKey && this.bottom) {
					this.bottom.focus()
					break
				}

				if (this.last) {
					this.last.focus()
					break
				}
				return
			}
			default: return
		}

		event.preventDefault()
		event.stopPropagation()
	}

	/** @param {PointerEvent} event */
	onClick = (event) => {
		event.stopPropagation()
	}

	/** @param {MouseEvent} event */
	onDoubleClick = (event) => {
		event.stopPropagation()
	}

	get isFocused() {
		return this.element == document.activeElement
	}

	/** @returns {import("./row_controller").default} */
	get row() {
		return this.application.getControllerForElementAndIdentifier(
			this.element.closest(`[data-controller="treegrid--row"]`), "treegrid--row"
		)
	}

	/** @returns {import("./cell_controller").default} */
	get cell() {
		return this.application.getControllerForElementAndIdentifier(
			this.element.closest(`[data-controller="treegrid--cell"]`), "treegrid--cell"
		)
	}

	get next() {
		const atoms = this.cell.atoms

		return atoms[atoms.indexOf(this) + 1] ?? this.cell.next
	}

	get prev() {
		const atoms = this.cell.atoms

		return atoms[atoms.indexOf(this) - 1] ?? this.cell.prev
	}

	get first() {
		return this.cell.first
	}

	get last() {
		return this.cell.last
	}

	/** @returns {TreegridAtomController} */
	get lower() {
		const index = this.cell.atoms.indexOf(this)

		for (let cell = this.cell; cell = cell.lower;) {
			if (cell.atoms[index]) {
				return cell.atoms[index]
			}
		}
	}

	/** @returns {TreegridAtomController} */
	get upper() {
		const index = this.cell.atoms.indexOf(this)

		for (let cell = this.cell; cell = cell.upper;) {
			if (cell.atoms[index]) {
				return cell.atoms[index]
			}
		}
	}

	get top() {
		const index = this.cell.atoms.indexOf(this)

		return this.cell.top.atoms[index]
	}

	get bottom() {
		const index = this.cell.atoms.indexOf(this)

		return this.cell.bottom.atoms[index]
	}

	focus() {
		this.element.focus()
	}
}
